import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import FormInput from '../../../../../library/form/components/FormInput';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import FormSearchButton from '../../../../../library/form/components/FormSearchButton';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import * as fn from "../../../../../helper/uiFunctions";
import ProdIOListQtyCell, { ProdIOListUnitCell } from './ProdIOListQtyCell';

const ProdTaskWastageRow = (props) => {
    const { formObject, viewData, rowKey } = props;

    const renderItemField = () => {
        if (viewData.rowValues.actualItem.val === '0') {
            return (
                <li className="uiColumnLeft uiColumn200">
                    <FormSearchButton formObject={formObject} rowKey="" headerKey='lineItemLink'
                        text={<SarasTrans value="Select Item" />} placeHolder="Barcode / Id..."
                        action={{ actionId: "refresh", actionName: "prodTaskWaste", actionParam: {changeitem:"1", "wasteRowId": rowKey} }}
                        className='uiActionButton uiSpacerH5'
                    />
                </li>
            )
        }
        else{
            return(
                <>
                    <li className="uiColumnLeft uiColumn200">
                        <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                            action={{ paramName: "actualItem", actionId: "show" }}
                            linkProp={{ target: "_blank" }}
                        ></FormLink>
                    </li>
                </>
            )
        }
    }

    if (fn.compareNumber(viewData.dataList.isEditMode, 1)) {
        return (
            <ul className="uiDPEditLine uiTableRowLevel1">
                <li className="uiColumnLeft uiColumn130">
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "itemId" }} />
                </li>
                {renderItemField()}
                <ProdIOListUnitCell formObject={formObject} rowKey={rowKey} param1="unit1" param2="unit2" />
                <li className="uiColumnRight uiColumnQty">
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit uiWidth50p" action={{ InputType: "input", actionId: "refresh", paramName: "qtyIssued1", actionParam:{actionType:"qtyIssueChanged"} }} />
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit uiWidth50p" action={{ InputType: "input", actionId: "refresh", paramName: "qtyIssued2", actionParam:{actionType:"qtyIssueChanged"} }} />
                </li>
                <li className="uiColumnRight uiColumnQty">
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit uiWidth50p" action={{ InputType: "input", actionId: "refresh", paramName: "qtyWasted1", actionParam:{actionType:"qtyWasteChanged"} }} />
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit uiWidth50p" action={{ InputType: "input", actionId: "refresh", paramName: "qtyWasted2", actionParam:{actionType:"qtyWasteChanged"} }} />
                </li>
                <li className="uiColumnRight uiColumnQty">
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit uiWidth50p" action={{ InputType: "input", actionId: "refresh", paramName: "qtyDamaged1", actionParam:{actionType:"qtyDamageChanged"} }} />
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit uiWidth50p" action={{ InputType: "input", actionId: "refresh", paramName: "qtyDamaged2", actionParam:{actionType:"qtyDamageChanged"} }} />
                </li>
                <li className="uiColumnRight uiColumnQty">
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit uiWidth50p" action={{ InputType: "input", actionId: "refresh", paramName: "qtyLost1", actionParam:{actionType:"qtyLossChanged"} }} />
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit uiWidth50p" action={{ InputType: "input", actionId: "refresh", paramName: "qtyLost2", actionParam:{actionType:"qtyLossChanged"} }} />
                </li>
                <li className="uiColumnRight uiColumnQty">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "percWaste" }} />
                </li>
                <li className="uiColumnRight uiColumnQty">
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit" action={{ InputType: "input", actionId: "refresh", paramName: "percAllowance", actionParam:{actionType:"perAllwChanged"} }} />
                </li>
                <li className="uiColumnRight uiColumnQty">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyAllowanced" }} />
                </li>
                <li className="uiColumnRight uiColumnQty">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyDiff" }} />
                </li>
                <li className="uiColumnRight uiColumn70">
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit" action={{ InputType: "input", paramName: "itemUnitCost" }} />
                </li>
                <li className="uiColumnRight uiColumn70">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "wastageValue" }} />
                </li>
                <li className="uiColumnRight uiColumn70">
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit" action={{ InputType: "input", paramName: "deduction" }} />
                </li>
                <li className="uiColumnLeft uiColumn70">
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit" action={{ InputType: "input", paramName: "comment" }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="confirm"
                        onlyIcon={true}
                        tooltip="Confirm Changes"
                        starIconClassName="uiColorNeutralAction"
                        action={{ actionId: "save", actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>

                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="cancel"
                        onlyIcon={true}
                        tooltip="Cancel Changes"
                        starIconClassName="uiColorNegativeAction"
                        action={{ actionId: "cancel", actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>
                </li>
            </ul>
        )
    }
    else {
        return (
            <ul className="uiDPEditLine uiTableRowLevel1">
                <li className="uiColumnLeft uiColumn130">
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "itemId" }} />
                </li>
                <li className="uiColumnLeft uiColumn200">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "actualItem", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <ProdIOListUnitCell formObject={formObject} rowKey={rowKey} param1="unit1" param2="unit2" />
                <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyIssued1" param2="qtyIssued2" format="a" />
                <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyWasted1" param2="qtyWasted2" format="a" />
                <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyDamaged1" param2="qtyDamaged2" format="a" />
                <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyLost1" param2="qtyLost2" format="a" />
                <li className="uiColumnRight uiColumnQty">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "percWaste" }} />
                </li>
                <li className="uiColumnRight uiColumnQty">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "percAllowance" }} />
                </li>
                <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyAllowanced1" param2="qtyAllowanced2" format="a" />
                <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyDiff1" param2="qtyDiff2" format="a" />
                <li className="uiColumnRight uiColumn70">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemUnitCost" }} />
                </li>
                <li className="uiColumnRight uiColumn70">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "wastageValue" }} />
                </li>
                <li className="uiColumnRight uiColumn70">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "deduction" }} />
                </li>
                <li className="uiColumnLeft uiColumn70">
                    <FormROValue maxValueLength={100} formObject={formObject} rowKey={rowKey} action={{ paramName: "comment" }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="edit"
                        onlyIcon={true}
                        tooltip="Edit"
                        starIconClassName="uiColorNeutralAction"
                        action={{ actionId: "edit", actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="clear"
                        onlyIcon={true}
                        tooltip="Delete"
                        starIconClassName="uiColorNegativeAction"
                        action={{ actionId: "del",  actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>
                </li>
            </ul>
        )
    }
}

export default ProdTaskWastageRow
